import { lm } from "../../../tools/language/LanguageManager";

export class JavaCompiledModuleMessages {
    static staticInitializerComment = () => lm({
    "de": "Code zum Initialisieren der statischen Attribute",
    "en": "Code to initialize static fields",
    })
}